import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		this.dialog = this.el.nextElementSibling;
		this.parent = this.el.parentElement.parentElement;
		this.showButton = this.el;
		this.closeButton = this.dialog.querySelector("button");

		this.showButton.addEventListener("click", () => {
            this.dialog.showModal();
			this.parent.classList.add("is-active");
        });

		this.parent.addEventListener("click", () => {
            this.dialog.showModal();
			this.parent.classList.add("is-active");
        });

        // "Close" button closes the dialog
        this.closeButton.addEventListener("click", this.closeDialog.bind(this));

        // Clicking the backdrop closes the dialog
        this.dialog.addEventListener("click", (event) => {
            if (event.target === this.dialog) {
                this.closeDialog();
            }
        });
    }

	closeDialog(event) {
        if (event) {
            event.stopPropagation();
        }

        this.dialog.setAttribute("closing", "");

        this.dialog.addEventListener(
            "animationend",
            () => {
                this.dialog.removeAttribute("closing");
                this.dialog.close();
				this.parent.classList.remove("is-active");
            },
            { once: true }
        );
    }
}
